import format from 'format-duration';

export const DurationBadge = ({ durationInSeconds }: { durationInSeconds: number }) => {

    return (
        <div className="text-sm bg-opacity-90 opacity-90 rounded-md py-[2px] px-[4px] text-sm bg-base-300 absolute top-1 right-1">{format(durationInSeconds * 1000, { leading: true })}</div>
    )
}